import { render, staticRenderFns } from "./examData.vue?vue&type=template&id=dc31b4e6&scoped=true&"
import script from "./examData.vue?vue&type=script&lang=js&"
export * from "./examData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc31b4e6",
  null
  
)

export default component.exports